import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage/LoginPage';
import './App.css'
import Register from './pages/RegistrationPage/Register';
import UserProfile from './profile/UserProfile';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage/>} />
        <Route path="/register" element={<Register/>} /> 
        <Route path="/user-profile" element={<UserProfile/>} />
      </Routes>
    </Router>
  );
}

export default App;
